import { z } from "zod";
import type { ProductionQuantityUnitOptions } from "./models";
import { normalizedProductionUnit } from "./quantity-unit-options";

const confirmationSchema = z.object({
  runId: z.string().min(1), runVersion: z.number().int().nonnegative(), productCode: z.string().min(1),
  boxesPerCase: z.number().int().min(1).max(1_000_000), countedUnit: z.literal("KUTU"),
  source: z.literal("OPERATOR_CONFIRMED"), confirmedAt: z.string().datetime(), confirmedByName: z.string(),
  ledgerApplied: z.boolean(), ledgerFactor: z.number().positive().nullable(),
  usage: z.enum(["START_BASELINE", "DISPLAY_ONLY"]),
});
export type CasePackagingConfirmation = z.infer<typeof confirmationSchema>;
export function decodeCasePackagingConfirmation(value: unknown) { return confirmationSchema.nullable().parse(value); }

export type OperatorProductPackaging = {
  boxesPerCase: number; unit: string; source: "MIKRO_ERP" | "OPERATOR_CONFIRMED"; observedAt: string;
};
/** Stock-card evidence belongs to a product, independently of the run's frozen counter baseline. */
export function operatorProductPackaging(contract: ProductionQuantityUnitOptions | null, productCode: string, primaryUnit: string): OperatorProductPackaging | null {
  if (!contract?.available || contract.source !== "MIKRO_ERP" || contract.productCode !== productCode ||
    normalizedProductionUnit(primaryUnit) !== "KOLI" || normalizedProductionUnit(contract.primaryUnit) !== "KOLI" ||
    !Number.isFinite(Date.parse(contract.observedAt ?? ""))) return null;
  const options = contract.options.filter((option) => ["KUTU", "SILINDIR"].includes(normalizedProductionUnit(option.unit)));
  const option = options.length === 1 ? options[0] : null;
  if (!option || !Number.isSafeInteger(option.factorToPrimary) || option.factorToPrimary < 1 || !contract.observedAt) return null;
  return { boxesPerCase: option.factorToPrimary, unit: option.unit, source: "MIKRO_ERP", observedAt: contract.observedAt };
}
